import React from 'react';
import { PaletteIcon, Code2Icon, ZapIcon, TargetIcon } from 'lucide-react';
export function WhatWeDoSection() {
  const pillars = [{
    icon: <PaletteIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-214" />,
    title: 'World-class design',
    desc: 'Premium UI/UX that elevates your brand identity.'
  }, {
    icon: <Code2Icon className="w-6 h-6 text-[#D4AF37]" data-id="element-215" />,
    title: 'Enterprise development',
    desc: 'Clean, scalable code built for high-volume stores.'
  }, {
    icon: <ZapIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-216" />,
    title: 'Performance optimization',
    desc: 'Lightning-fast load times that reduce bounce rates.'
  }, {
    icon: <TargetIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-217" />,
    title: 'Conversion psychology',
    desc: 'Data-driven layouts designed to maximize sales.'
  }];
  return <section className="section-padding bg-[#050505] relative" data-id="element-218">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-219">
        <div data-id="element-220">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-221">What We Do</h2>
          <p className="text-xl text-gray-400 leading-relaxed mb-8" data-id="element-222">
            At Design Flow Digitals, we design and build powerful Shopify
            experiences for modern brands.
          </p>
          <p className="text-lg text-gray-400 leading-relaxed mb-10" data-id="element-223">
            From custom Shopify themes and apps to high-converting storefronts,
            we help businesses create fast, scalable and visually stunning
            ecommerce experiences.
          </p>

          {/* Stats Row */}
          <div className="flex gap-8 mb-10 pb-10 border-b border-white/10" data-id="element-224">
            <div data-id="element-225">
              <p className="text-4xl font-bold text-white mb-1" data-id="element-226">
                99<span className="text-[#D4AF37]" data-id="element-227">%</span>
              </p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-medium" data-id="element-228">
                Client Satisfaction
              </p>
            </div>
            <div className="w-[1px] bg-white/10" data-id="element-229" />
            <div data-id="element-230">
              <p className="text-4xl font-bold text-white mb-1" data-id="element-231">
                2.5<span className="text-[#D4AF37]" data-id="element-232">x</span>
              </p>
              <p className="text-sm text-gray-500 uppercase tracking-wider font-medium" data-id="element-233">
                Avg. Conv. Lift
              </p>
            </div>
          </div>

          <div className="inline-block p-[1px] rounded-2xl bg-gradient-to-r from-[#F3E5AB]/30 via-[#D4AF37]/30 to-transparent shadow-[0_0_20px_rgba(212,175,55,0.1)]" data-id="element-234">
            <div className="bg-[#0a0a0a] rounded-2xl p-6" data-id="element-235">
              <p className="text-xl font-medium text-white" data-id="element-236">
                The result:{' '}
                <span className="text-gradient-gold font-bold" data-id="element-237">
                  Shopify stores that look beautiful and sell more.
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-238">
          {pillars.map((pillar, index) => <div key={index} className="glass-card p-8 flex flex-col gap-4 transition-all duration-300 hover:-translate-y-2 hover:border-[#D4AF37]/30 hover:shadow-[0_10px_30px_-10px_rgba(212,175,55,0.15)] group" data-id="element-239">
              <div className="w-14 h-14 rounded-full bg-[#D4AF37]/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300" data-id="element-240">
                {pillar.icon}
              </div>
              <div data-id="element-241">
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#D4AF37] transition-colors" data-id="element-242">
                  {pillar.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-243">
                  {pillar.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}